window.theme = window.theme || {};
window.theme.RS = window.theme.RS || {};

function handleTabs() {
  var tabLinks = document.querySelectorAll(".js-customer-tab");
  var tabContents = document.querySelectorAll(".js-customer-tabcontent");
  var tabCallback = function(evt, newFocus) {
    evt.preventDefault();
    var tabName = evt.target.getAttribute('data-tab');
    var currentIndex = +evt.target.getAttribute('data-index');
    var targetTabPanel = document.querySelector('.js-customer-tabcontent[data-tab="' + tabName + '"]');
    var targetTab = document.querySelector('.js-customer-tab[data-tab="' + tabName + '"]');
    handleTabReset(tabLinks, tabContents)

    if (newFocus && evt.type === 'keydown'){
      handleTabFocus(tabLinks, tabContents, currentIndex, newFocus)
    }
    if (evt.type === 'click') {
      handleTabSet(targetTab, targetTabPanel)
    }
  }

  tabLinks.forEach(function(ele) {
    ele.addEventListener('click', tabCallback)
  })
  
  tabLinks.forEach(function(ele) {
    ele.addEventListener('keydown', function(e){
      if (e.keyCode === 39) {
        tabCallback(e, 'next')
      }
      if (e.keyCode === 37) {
        tabCallback(e, 'previous')
      }
    })
  })
}

function handleTabFocus(tabLinks, tabContents, index, newFocus) {
  var tabLinkNewFocus;

  if (Number.isInteger(index) && tabLinks) {
    if (newFocus === 'next') {
      index + 1 < tabLinks.length ? tabLinkNewFocus = index + 1 : tabLinkNewFocus = 0;
    }
    if (newFocus === 'previous') {
      index > 0 ? tabLinkNewFocus = index - 1 : tabLinkNewFocus = tabLinks.length - 1;
    }
    console.log(index, tabLinkNewFocus)
    handleTabSet(tabLinks[tabLinkNewFocus], tabContents[tabLinkNewFocus])
    tabLinks[tabLinkNewFocus].focus()
    
  }
}

function handleTabReset(tabLinks, tabContents) {
  for (var i=0; i < tabContents.length; i++) {
    tabContents[i].classList.add('hidden');
    tabContents[i].setAttribute('tabindex', -1)
  }
  for (var j=0; j < tabLinks.length; j++) {
    tabLinks[j].classList.remove('is--active');
    tabLinks[j].setAttribute('tabindex', -1)
    tabLinks[j].setAttribute('aria-selected', false)
  }
}

function handleTabSet(targetTab, targetTabPanel) {
  targetTabPanel.classList.remove('hidden');
  targetTabPanel.setAttribute('tabindex', 0)
  targetTab.classList.add('is--active');
  targetTab.setAttribute('tabindex', 0)
  targetTab.setAttribute('aria-selected', true)
}

function toggleRecoverPassword() {
  var recoverLinks = document.querySelectorAll('.js-toggle-recover');

  recoverLinks.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();

      document.getElementById('CustomerTabWrapper').classList.toggle('is--hidden');
      document.getElementById('CustomerRecoverPassword').classList.toggle('is--hidden');
    })
  })
}

function togglePasswordField() {
  var toggleButton = document.getElementById('passwordEyeToggle');
  var passwordField = document.getElementById('CustomerLoginPassword');

  if(!toggleButton) return;

  toggleButton.addEventListener('click', function(evt) {
    evt.preventDefault();
    const passwordSVGs = document.querySelectorAll('#passwordEyeToggle svg');
    const isVisible = passwordSVGs[1].classList.contains('hidden');
    
    const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
    passwordField.setAttribute('type', type);
    passwordSVGs.forEach(function(ele){ele.classList.toggle('hidden')})
    toggleButton.setAttribute('aria-label', isVisible ? "hide password" : "show password")
  })
}

function toggleAddNewAddressForm() {
  var toggleButton = document.querySelectorAll(".js-toggle-newaddress");
  var addressFormWrap = document.getElementById('NewAddressForm');

  toggleButton.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();

      for (var i=0; i < toggleButton.length; i++) {
        var isExpanded = toggleButton[i].getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
        toggleButton[i].classList.toggle('is--hidden');
        toggleButton[i].setAttribute('aria-expanded', isExpanded)
      }

      addressFormWrap.classList.toggle('hidden');
    })
  })
}

function toggleEditAddressForm() {
  var toggleButton = document.querySelectorAll(".js-toggle-editaddress");

  toggleButton.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      evt.preventDefault();
      
      for (var i=0; i < toggleButton.length; i++) {
        var isExpanded = toggleButton[i].getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
        toggleButton[i].classList.toggle('is--hidden');
        toggleButton[i].setAttribute('aria-expanded', isExpanded)
      }
      var addressId = this.getAttribute('data-address');
      var editFormWrap = document.getElementById('EditAddress_' + addressId);
      editFormWrap.classList.toggle('hidden');
    })
  })
}

function generateStateSelector() {
  var countrySelector = document.getElementById('AddressNewCountry');
  var editCountryList = document.getElementById('EditAddressList');
  
  if(countrySelector) {
    new Shopify.CountryProvinceSelector('AddressNewCountry', 'AddressNewState', {hideElement: 'AddressNewStateContainer'});  
  }
  if(editCountryList) {
    var addressIds = JSON.parse(document.getElementById('EditAddressList').getAttribute('data-address-ids'));

    for(var i=0; i < addressIds.length; i++) {
      var countryId = 'AddressEditCountry-' + addressIds[i];
      var stateId = 'AddressEditState-' + addressIds[i];
      var stateContainerId = 'AddressEditStateContainer-' + addressIds[i];

      new Shopify.CountryProvinceSelector(countryId, stateId, {hideElement: stateContainerId}); 
    }
  }
}

function slideToggle(container) {
  if (!container.classList.contains('accordion--active')) {      
    container.classList.add('accordion--active');
    container.style.height = 'auto';

    var height = container.clientHeight + 'px';
    container.style.height = '0px';
    setTimeout(function () {
      container.style.height = height;
    }, 0);    
  } else {    
    container.style.height = '0px';
    container.addEventListener('transitionend', function() {
      container.classList.remove('accordion--active');
    }, {
      once: true
    });    
  }
}

function footerMobileAccordion() {
  var accordionHeadings = document.querySelectorAll(".js-footer-accordion");

  accordionHeadings.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
      if (window.screen.width < 768) {
        var accordionName = this.getAttribute('data-accordion');
        var accordionContent = document.querySelector('.js-footer-content[data-accordion="'+ accordionName +'"]');
        
        this.classList.toggle('accordion--active');
        this.setAttribute('aria-expanded', this.classList.contains('accordion--active'))
        !evt.target.classList.contains('link') ? slideToggle(accordionContent) : null;
      }
    })
  })
}

function footerDesktopAccordion() {
  var accordionHeading = document.getElementById("footerHeadingDesktop");
  var accordionContent = document.getElementById("footerContentDesktop");
  if (accordionHeading) {
    var toggleFooterButton = accordionHeading.querySelector('button.showHide');
  }
  
  accordionHeading.addEventListener('click', function(evt) {
    evt.preventDefault();

    accordionHeading.classList.toggle('accordion--active');
    accordionContent.classList.toggle('is--active');
    if (toggleFooterButton) {
      toggleFooterButton.setAttribute('aria-expanded', toggleFooterButton.getAttribute('aria-expanded') === "true" ? false : true)
      toggleFooterButton.setAttribute('aria-label', toggleFooterButton.getAttribute('aria-expanded') === "true" ? "collapse footer region" : "expand footer region")
    }
  })
}

function updateLoyaltyLionInfo() {
  if(document.querySelector('.template-account')) {
    var currentTierElement = document.querySelector('[data-current-tier-name]');

    var attempt = 1;
    var getLoyaltyLionElement = setInterval(function() {
      if(attempt > 30) {
        clearInterval(getLoyaltyLionElement)
      } else {
        var loyaltyEl = document.querySelector('[data-lion-tier-overview] .lion-tier-box--current .lion-tier-box__title');

        if(loyaltyEl) {
          currentTierElement.innerHTML = loyaltyEl.innerHTML;
          clearInterval(getLoyaltyLionElement);
        }
      }
    }, 500);    
  }
}

function activateSkipLink() {
  const skipLinkEl = document.querySelector('.skip-link');
  const newFocusEl = document.querySelector('#main');
    if (skipLinkEl) {
      skipLinkEl.addEventListener('click', () => {
        newFocusEl ? newFocusEl.focus() : null
    })
  }
}

function setTabIndex(el, tabIdx) {
  if (el && tabIdx) {
    el.setAttribute('tabindex', tabIdx)
  }
}

function removeDisabledButtonsFromFlow() {
  //content is injected after DOMContentLoaded event
  setTimeout(() => {
    const buttonEls = document.querySelectorAll('.lion-action-button');

    buttonEls.forEach((el) => {
      const isDisabled = el.classList.contains('lion-action-button--disabled');
      if (isDisabled) {
        setTabIndex(el, -1)
        el.setAttribute('disabled', true)
      } 
    })
  }, 1000);
}

function removeUnnecessaryOkeAttributtes() {
  const targetEls = document.querySelectorAll('.okeReviews-reviewsSummary') || [];
  //content is injected after DOMContentLoaded event. Oke is quite slow in response time.
  setTimeout(() => {
    targetEls.forEach((el) => {
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
    })
  }, 3500);
}

function showSkipToContentLink() {
  const skipLinkEl = document.querySelector('.skip-link')
  if (skipLinkEl) {
    skipLinkEl.classList.remove('hidden')
  }
}

window.theme.RS.Account = (function() {
  const Account = {};
  const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'd34ba21c3c685ebf6b248c2b4015c138';
  const GRAPHQL_URL = window.location.origin + "/api/graphql";
  const ACCESS_TOKEN_KEY = '_rs_a_t';
  const ACCOUNT_UPDATE_SELECTOR = '[data-action="update-customer"]';
  const PW_RECOVER_SELECTOR = '[data-action="recover-password"]';
  const PW_RECOVER_SUBMIT_SELECTOR = '[data-action="submit-recover-password"]';
  const NOTIFICATION_DATASET = 'notificationId';
  const NOTIFICATION_ATTR = 'data-notification';
  const DISABLE_ATTR = 'disabled';
  const EMAIL_NAME_SELECTOR = '[name="customer[email]"]';
  const PW_NAME_SELECTOR = '[name="customer[password]"]';
  const EMAIL_ORIG_NAME_SELECTOR = '[name="customer[original_email]"]';
  const FIRST_NAME_NAME_SELECTOR = '[name="customer[first_name]"]';
  const LAST_NAME_NAME_SELECTOR = '[name="customer[last_name]"]';
  const HIDE_CLASS = 'hidden';
  const INVISIBLE_CLASS = 'rs-invisible';
  const VISIBLE_CLASS = 'rs-visible';
  const DISABLE_CLASS = 'button-disabled';
  const NOTIFICATION_SUCCESS_CLASSES = [
    'text-success',
    'bg-success'
  ];
  const NOTIFICATION_ERROR_CLASSES = [
    'text-error',
    'bg-error'
  ];

  function toggleHideClass(show, elem) {
    if (elem) {
      if (show) {
        elem.classList.add(VISIBLE_CLASS);
        elem.classList.remove(INVISIBLE_CLASS);
      } else {
        elem.classList.add(INVISIBLE_CLASS);
        elem.classList.remove(VISIBLE_CLASS);
      }
    }
  }

  function applyNotificationClasses(isSuccess, elem) {
    if (elem && elem.classList) {
      const removeClass = isSuccess ? NOTIFICATION_ERROR_CLASSES : NOTIFICATION_SUCCESS_CLASSES;
      const addClass = isSuccess ? NOTIFICATION_SUCCESS_CLASSES : NOTIFICATION_ERROR_CLASSES
        elem.classList.remove.apply(elem.classList, removeClass);
        elem.classList.add.apply(elem.classList, addClass);
    }
  }

  Account.TOKEN_SET_EVENT = 'RS:Account:tokenSet';

  Account.createCustomerAccessTokenQuery = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerUserErrors {
        code
        field
        message
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
    }
  }`;

  Account.updateCustomerQuery = `mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
    customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`;

  Account.fetchToken = function fetchToken(email, pw) {
    if (email && pw) {     
      const tokenSetEvent = new CustomEvent(Account.TOKEN_SET_EVENT); 
      const xhr = new XMLHttpRequest();
      xhr.open("POST", GRAPHQL_URL, false);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", SHOPIFY_STOREFRONT_ACCESS_TOKEN);
    
      const requestBody = {
        query: Account.createCustomerAccessTokenQuery,
        variables: {
          input: {
            email: email,
            password: pw
          }
        }
      };
      
      xhr.onreadystatechange = function() {
        if (this.readyState == 4) {
          let response = {};
          let responseData = {};
          let errors = [];
          try {
            const responseText = JSON.parse(this.responseText || '{}');
            responseData = (responseText && responseText.data ? responseText.data : {}) || {};
            response = responseData && responseData.customerAccessTokenCreate ? responseData.customerAccessTokenCreate : {};
          } catch (error) {
            console.log('RS:Notification: JSON parse error in fetchToken. ', error);
          }

          if (!response) {
            response = {};
          }

          errors = responseData && responseData.errors ? responseData.errors : [];

          if (errors.length != 0) {
            console.error(errors);
          } else {
            const customerAccessToken = response.customerAccessToken || {};
            const accessToken = customerAccessToken.accessToken;
            const expirationDate = customerAccessToken.expiresAt;
            const payload = JSON.stringify({ token: accessToken || '', expiration: expirationDate || '' })

            if (accessToken) {
              sessionStorage.setItem(ACCESS_TOKEN_KEY, payload);
              document.dispatchEvent(tokenSetEvent);
            } else {
              Account.clearToken();
            }
          }
        }
      };
      
      xhr.send(JSON.stringify(requestBody));
    }
  };

  Account.clearToken = function clearToken() {
    const tokenClearedEvent = new CustomEvent(Account.TOKEN_SET_EVENT); 
    sessionStorage.setItem(ACCESS_TOKEN_KEY, '{}');
    document.dispatchEvent(tokenClearedEvent);
  };

  Account.getAccessToken = function getAccessToken() {
    const accessTokenString = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    let accessToken = '';

    if (accessTokenString) {
      try {
        accessToken = (JSON.parse(accessTokenString) || {}).token || '';
      } catch (error) {
        console.log('RS:Notification: JSON parse error in getAccessToken. ', error);
      }
    } else {
      console.log('RS:Notification: Missing token. ');
    }

    return accessToken;
  };

  Account.onLoginHandler = function onLoginHandler(e) {
    const target = e && e.target ? e.target : null;
    if (target) {
      const emailElem = target.querySelector(EMAIL_NAME_SELECTOR);
      const pwElem = target.querySelector(PW_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';
      const pw = pwElem ? pwElem.value : '';
      Account.fetchToken(email, pw);
    }
  };

  Account.registerOnLoginListener = function registerOnLoginListener() {
    const elems = document.querySelectorAll('[data-action="fetchToken"]');
    if (elems.length) {
      elems.forEach(function(elem) {
        elem.addEventListener('submit', Account.onLoginHandler);
      });
    }
  };

  Account.updateAndShowNoficiation = function updateAndShowNoficiation(form, error, isSuccess, show) {
    if (form) {
      const notificationId = form.dataset[NOTIFICATION_DATASET] || '';
      const elem = notificationId ? document.querySelector('[' + NOTIFICATION_ATTR + '="' + notificationId + '"]') : null;
      if (elem) {
        elem.innerHTML = error || '';
        applyNotificationClasses(isSuccess, elem);
        toggleHideClass(show, elem);
      }
    }
  };

  Account.toggleSubmit = function togleSubmit(form, elem, disable) {
    let submit = elem;

    if (!submit && form) {
      submit = form.querySelector(PW_RECOVER_SUBMIT_SELECTOR) || form.querySelector('[type="submit"]');
    }

    if (submit) {
      if (disable) {
        submit.setAttribute(DISABLE_ATTR, 'true');
        submit.classList.add(DISABLE_CLASS);
      } else {
        submit.removeAttribute(DISABLE_ATTR);
        submit.classList.remove(DISABLE_CLASS);
      }
    }
  };

  Account.onUpdateSuccessHandler = function onUpdateSuccessHandler(form) {
    if (form) {
      const recoverForms = document.querySelectorAll(PW_RECOVER_SELECTOR);
      const emailElem = form.querySelector(EMAIL_NAME_SELECTOR);
      const emailOrigElem = form.querySelector(EMAIL_ORIG_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';

      Account.updateAndShowNoficiation(form, 'Successfully updated customer information', true, true);
      if (email) {
        // Update original email to new email value
        if (emailOrigElem) {
          emailOrigElem.value = email;
        }

        // Update all recover form email input values to new email
        recoverForms.forEach(function(form) {
          const emailElem = form.querySelector('[name="email"]');
          if (emailElem) {
            emailElem.value = email;
          }
        });
      }
    }
  };

  Account.onUpdateErrorHandler = function onUpdateSuccessHandler(form) {
    if (form) {
      Account.updateAndShowNoficiation(
        form,
        window.theme.strings.customer.account.update_error_msg,
        false,
        true
      );
    }
  };

  Account.updateCustomer = function updateCustomer(form) {
    if (form) {
      const emailElem = form.querySelector(EMAIL_NAME_SELECTOR);
      const pwElem = form.querySelector(PW_NAME_SELECTOR);
      const emailOrigElem = form.querySelector(EMAIL_ORIG_NAME_SELECTOR);
      const firstNameElem = form.querySelector(FIRST_NAME_NAME_SELECTOR);
      const lastNameElem = form.querySelector(LAST_NAME_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';
      const pw = pwElem ? pwElem.value : '';
      const emailOrig = emailOrigElem ? emailOrigElem.value : '';
      const firstName = firstNameElem ? firstNameElem.value : '';
      const lastName = lastNameElem ? lastNameElem.value : '';
      let accessToken = Account.getAccessToken();

      Account.toggleSubmit(form, null, true);
  
      if (!accessToken) {
        const fetchTokenHandler = function() {
          Account.updateCustomer(form);
          document.removeEventListener(Account.TOKEN_SET_EVENT, fetchTokenHandler);
        };

        document.addEventListener(Account.TOKEN_SET_EVENT, fetchTokenHandler);
        Account.fetchToken(emailOrig, pw);
      } else if (firstName || lastName || email) {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", GRAPHQL_URL);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", SHOPIFY_STOREFRONT_ACCESS_TOKEN);

        const requestBody = {
          query: Account.updateCustomerQuery,
          variables: {
            "customerAccessToken": accessToken,
            "customer": {}
          }
        };

        if (firstName) {
          requestBody.variables.customer.firstName = firstName;
        }
        if (lastName) {
          requestBody.variables.customer.lastName = lastName;
        }
        if (email) {
          requestBody.variables.customer.email = email;
        }

        xhr.onreadystatechange = function() {
          if (this.readyState == 4) {
            let response = {};
            let responseData = {};
            let errors = [];
            try {
              const responseText = JSON.parse(this.responseText || '{}');
              responseData = (responseText && responseText.data ? responseText.data : {}) || {};
              response = responseData && responseData.customerAccessTokenCreate ? responseData.customerAccessTokenCreate : {};
            } catch (error) {
              console.log('RS:Notification: JSON parse error in fetchToken. ', error);
            }
  
            if (!response) {
              response = {};
            }
  
            errors = responseData && responseData.errors ? responseData.errors : [];
  
            if (errors.length != 0) {
              console.error(errors);
            } else {
              Account.onUpdateSuccessHandler(form);
            }
            Account.toggleSubmit(form, null);
          }
        };

        xhr.send(JSON.stringify(requestBody));
      }

      // Password field can be hidden and disabled once accessToken is set
      if (accessToken && pwElem) {
        const parent = pwElem.parentNode;
        if (parent) {
          parent.classList.add(HIDE_CLASS);
          pwElem.setAttribute('disabled', 'disabled');
        }
      }
    }
  };

  Account.onAccountUpdateHandler = function onAccountUpdateHandler(e) {
    e.preventDefault();
    const form = e && e.target ? e.target : null;
    Account.updateCustomer(form);
  };

  Account.registerAccountUpdateListener = function registerAccountUpdateListener() {
    const elems = document.querySelectorAll(ACCOUNT_UPDATE_SELECTOR);
    if (elems.length) {
      const accessToken = Account.getAccessToken();
      elems.forEach(function(elem) {
        elem.addEventListener('submit', Account.onAccountUpdateHandler);

        // If access token is not set and customer is already logged in, they 
        // must enter their password. This is an additional check. The access
        // token should get set on log in.
        if (!accessToken) {
          const pwElem = elem.querySelector(PW_NAME_SELECTOR);
          const parent = pwElem ? pwElem.parentNode : null;
          if (parent) {
            parent.classList.remove(HIDE_CLASS);
            pwElem.removeAttribute('disabled');
          }
        }
      });
    }
  };

  Account.onPasswordRecoverHandler = function onUpdatePassword(e) {
    if (e && e.target) {
      e.preventDefault();
      const submit = e.target;
      const form = submit ? submit.closest(PW_RECOVER_SELECTOR) : null;
      const emailInput = form ? form.querySelector('[name="email"]') : null;
      const email = emailInput ? emailInput.value : '';
      
      if (form) {
        Account.toggleSubmit(form, submit, true);
  
        fetch(
          'https://hatheaven.com/account/recover',
          {
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: email
            })
          }
        )
        .then(function(response) {
          let errorMsg = '';
          if (response && response.ok) {
            Account.onPasswordRecoverSuccess(form);
          } else {
  
            if (response && response.status === 429) {
              errorMsg = 'Too many attempts. Please wait a few minutes and try again.';
            }
            Account.onPasswordRecoverError(form, errorMsg);
          }
        })
        .catch(function(error) {
          Account.onPasswordRecoverError(form);
        })
        .finally(function() {
          Account.toggleSubmit(form, submit);
        });
      }
    }
  };

  Account.onPasswordRecoverSuccess = function onPasswordRecoverSuccess(form) {
    const msg = `<p class="m-0">
                  Password reset instructions have been sent to your inbox.
                </pv>
                <p class="mt-2">
                  Follow the instructions in the email to reset your password. 
                </p>`;
    if (form) {
      Account.updateAndShowNoficiation(form, msg, true, true);
    }
  };

  Account.onPasswordRecoverError = function onPasswordRecoverError(form, msg) {
    if (form) {
      const errorMsg = msg || window.theme.strings.customer.account.update_error_msg;
      Account.updateAndShowNoficiation(
        form,
        errorMsg,
        false,
        true
      );
    }
  };

  Account.RegisterRecoverPasswordListener = function onUpdatePassword() {
    const elems = document.querySelectorAll(PW_RECOVER_SUBMIT_SELECTOR);
    if (elems) {
      elems.forEach(function(elem) {
        let timeout;

        // Using click instead of submit event. When using submit event, quick
        // submissions still get sent even with preventDefault called. Click 
        // events provides better control of actual form submission for this case.
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          Account.toggleSubmit(null, elem, true);
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            Account.onPasswordRecoverHandler(e);
          }, 500);
        });
      });
    }
  };
  return Account;
})();

window.theme.RS.Loader = (function() {
  const Loader = {};

  Loader.hideLoaderOnLoad = function hideLoaderOnLoad() {
    const loadWraps = document.querySelectorAll('[data-action="remove-loader-on-ready"]');
    loadWraps.forEach(function(elem) {
      const loader = elem.querySelector('[data-loader]');
      if (loader) {
        loader.classList.add('hidden');
      }
    });
  }
  return Loader;
})();

window.addEventListener("load", function() {
  handleTabs();
  toggleRecoverPassword();
  togglePasswordField();
  toggleAddNewAddressForm();
  toggleEditAddressForm();
  generateStateSelector();
  footerMobileAccordion();
  footerDesktopAccordion();
  updateLoyaltyLionInfo();
  activateSkipLink();
  removeDisabledButtonsFromFlow();
  removeUnnecessaryOkeAttributtes();
  showSkipToContentLink();
  
  window.theme.RS.Account.registerOnLoginListener();
  window.theme.RS.Account.registerAccountUpdateListener();
  window.theme.RS.Account.RegisterRecoverPasswordListener();
  window.theme.RS.Loader.hideLoaderOnLoad();
  
  // if (window.location.hash == '#recover') { 
  //   document.getElementById('CustomerTabWrapper').classList.add('is--hidden');
  //   document.getElementById('CustomerRecoverPassword').classList.remove('is--hidden');
  // }
});